import { getStoreInfo } from '@/api/user/indexApi'

export async function getCurrentStoreId() {
  let storeInfo = {}
  try {
    storeInfo = await getStoreInfo()
  } catch (error) {
    console.error('获取商户信息失败:', error)
  }
  if (storeInfo && storeInfo.storeId) {
    return storeInfo.storeId
  }
  if (storeInfo && storeInfo.data && storeInfo.data.storeId) {
    return storeInfo.data.storeId
  }

  const userInfo = JSON.parse(window.localStorage.getItem('user') || '{}')
  if (userInfo.storeId) {
    return userInfo.storeId
  }
  if (userInfo.storeInfo && userInfo.storeInfo.storeId) {
    return userInfo.storeInfo.storeId
  }
  return ''
}
